import { IconButton } from '@fluentui/react';
import React, { useMemo } from 'react';

const SvgIcon = (props) => {

    const {
        disabled = false,
        height = 23,
        id = undefined,
        onClick = event => console.log(event),
        src = undefined,
        title = undefined,
        width = "unset",
    } = props;

    const styles = useMemo(
        () => {
            let styles = {
                icon: { image: { height, width } },
                iconButton: {
                    root: { height: "unset" },
                    rootDisabled: {
                        background: "unset",
                        opacity: 0.5
                    },
                    rootHovered: {
                        background: "unset",
                        filter: "invert(10%) sepia(100%) saturate(6763%) hue-rotate(359deg) brightness(98%) contrast(110%)"
                    },
                    rootPressed: { background: "unset" },
                    icon: {
                        alignSelf: "flex-end",
                        height: "unset"
                    }
                },
            };

            return styles;
        },
        [height, width]
    );

    return <IconButton
        ariaLabel={title}
        disabled={disabled}
        iconProps={{ imageProps: { src, styles: styles.icon } }}
        id={id}
        onClick={onClick}
        styles={styles.iconButton}
        title={title}
    />;

};

export default SvgIcon;